import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import { Helmet } from 'react-helmet'
import Hero from '../components/hero/hero'
import TeamList from '../components/team/teamList'
import Services from '../components/services/services'
import Section from '../components/layout/section'
import News from '../components/news/news';
import Clients from '../components/clients/clients';

class RootIndex extends React.Component {
  render() {
    //const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    //const posts = get(this, 'props.data.allContentfulArtikel.edges')
    //const [author] = get(this, 'props.data.allContentfulPerson.edges')
   
    return (
        <>
          <Helmet title={`Derichs & Graalmann Kommunikation GmbH`}>
            <html lang="de" />          
          </Helmet>
         
          <Section><Hero /></Section> 
          <Section><News showLink={true} /></Section> 
          <Section><Services showLink={true} hideTitle={true}/></Section> 
          <Section small><Clients showLink={true}/></Section> 
          
          <div className="wrapper">
            <Section><TeamList /></Section>
          </div>
          
       

         {/* {posts.map(({ node }) => {
                return (
                  <Card key={node.slug} data={node} />
                )
              })}
            
            <h2 className="section-headline">Recent articles</h2>
            <ul className="article-list">
              {posts.map(({ node }) => {
                return (
                  <li key={node.slug}>
                    <ArticlePreview article={node} />
                  </li>
                )
              })}
            </ul>*/}
      </>
    )
  }
}

export default RootIndex

/*export const pageQuery = graphql`
  query HomeQuery {
    allContentfulArtikel(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allContentfulPerson(
      filter: { contentful_id: { eq: "15jwOBqpxqSAOy2eOO4S0m" } }
    ) {
      edges {
        node {
          name
          shortBio {
            shortBio
          }
          title
          heroImage: image {
            fluid(
              maxWidth: 1180
              maxHeight: 480
              resizingBehavior: PAD
              background: "rgb:000000"
            ) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`
*/